import { ComponentType, lazy, LazyExoticComponent } from 'react';

export const safeLazy = <T extends ComponentType<any>>(
  importFunction: () => Promise<{ default: T }>,
): LazyExoticComponent<T> => {
  return lazy(async () => {
    try {
      return await importFunction();
    } catch (error: unknown) {
      const err = error as Error;
      const reloadKey = 'chunk_error_reloaded';

      const isChunkLoadError =
        err?.name === 'ChunkLoadError' ||
        err?.message?.includes('Loading chunk') ||
        err?.message?.includes('Failed to fetch dynamically imported module') ||
        err?.message?.includes("Unexpected token '<'");

      if (isChunkLoadError) {
        const hasReloaded = sessionStorage.getItem(reloadKey);

        if (!hasReloaded) {
          sessionStorage.setItem(reloadKey, 'true');
          window.location.reload();
          return new Promise<{ default: T }>(() => {});
        }
      }

      throw error;
    }
  });
};

interface ComponentWithPreload extends LazyExoticComponent<ComponentType<any>> {
  preload: () => void;
}

export const LazyPreload = (path: () => Promise<{ default: ComponentType<any> }>) => {
  const Component = safeLazy(path) as ComponentWithPreload;
  Component.preload = path;
  return Component;
};
